import { APIClient } from '../api_helper';
import { api } from '../../config';
import * as url from './url_helper';

import qs from 'qs';
import axios from 'axios';

const apiClient = new APIClient(api.REACT_APP_SPED_FILE_MANAGER_API_URL);

export const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// File
// export const getFilesList = query =>
// 	apiClient.get(url.GET_FILES + '?' + stringifyParams(query));
export const getFilesList = query => apiClient.post(url.GET_FILES_QUERY, query);
export const getFile = file => apiClient.get(url.GET_ONE_FILE + file);
export const updateFile = file => apiClient.put(url.UPDATE_FILE, file);
export const updateFileFavourites = data => apiClient.put(`${url.UPDATE_FILE_FAVOURITES + data.file_id}?${stringifyParams({ action: data.action, })}`);
export const deleteFile = file_id => apiClient.delete(url.DELETE_FILE + '/' + file_id);

export const getFileType = (params) => { return apiClient.get(`${url.GET_FILE_TYPE}?${stringifyParams(params)}`); }
export const getFileTypeByCode = (code) => apiClient.get(url.GET_FILE_TYPE_BY_CODE + code);

// Folder
export const getFoldersList = query => apiClient.get(url.GET_FOLDERS + '?' + stringifyParams(query));
export const getFolder = folder => apiClient.get(url.GET_ONE_FOLDER + folder);
export const getFolderStructure = (params) => apiClient.get(url.GET_FOLDER_STRUCTURE + '?' + stringifyParams(params));
export const addNewFolder = folder => apiClient.post(url.ADD_FOLDER, folder);
export const updateFolder = data => apiClient.put(url.UPDATE_FOLDER + data.id, data.updateFolder);
export const deleteFolder = folder => apiClient.delete(url.DELETE_FOLDER, folder);

// Upload
export const uploadFiles = data =>
	apiClient.post(
		`${url.UPLOAD_FILES}${data.folder_id
			? `?${stringifyParams({
				folder_id: data.folder_id,
			})}`
			: ''
		}`,
		data.formData,
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);

export const uploadFile = data => {
	const queryString = data.file_path != null
		? `?${stringifyParams(
			Object.fromEntries(
				Object.entries({
					file_path: data.file_path,
					file_type_id: data.file_type_id,
					folder_id: data.folder_id,
					meta: data.meta
				}).filter(([key, value]) => value != null)
			)
		)}`
		: `?file_type_id=${encodeURIComponent(data.file_type_id)}`;

	return apiClient.post(
		`${url.UPLOAD_FILE}${queryString}`,
		data.formData,
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);
};

export const uploadFileImage = data => {
	return apiClient.post(
		`${url.UPLOAD_IMAGE}`,
		data.formData,
		{
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}
	);
};



// export const uploadFoldersFile = data => {
// 	let queryString = data.folder_paths && Array.isArray(data.folder_paths)
// 		? `?${data.folder_paths.map(path => `folder_paths=${encodeURIComponent(path)}`).join('&')}`
// 		: '';

// 	queryString += `&file_type_id=${encodeURIComponent(data.file_type_id)}`;
// 	queryString += `&establishment_id=${encodeURIComponent(data.establishment_id)}`;

// 	// Realiza la solicitud POST a la API
// 	return apiClient.post(
// 		`${url.UPLOAD_FOLDERS_FILE}${queryString}`,
// 		data.formData,
// 		{
// 			headers: {
// 				'Content-Type': 'multipart/form-data',
// 			},
// 		}
// 	);
// };

export const uploadFoldersFile = (formData) => {
	return apiClient.post(`${url.UPLOAD_FOLDERS_FILE}`, formData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
};




// Download
export const downloadFile = data =>
	apiClient.get(
		`${url.DOWNLOAD_FILE}${data.file_id
			? `?${stringifyParams({
				file_id: data.file_id,
			})}`
			: ''
		}`,
		{
			responseType: 'blob',
		}
	);


// Image
export const getImageBase64 = async (url_image) => {
	if (!url_image) {
		throw new Error("The URL is required.");
	}

	try {
		const response = await apiClient.post(`${url.DOWNLOAD_IMAGE_BASE64}?${stringifyParams({ url: url_image })}`, null);
		return response;
	} catch (error) {
		console.error('Error downloading image:', error);
		throw error;
	}
};



const imageCache = {};

export const getImageToken = async (url_image) => {
	if (!url_image) {
		throw new Error("The URL is required.");
	}

	// // Verifica si la imagen ya está en la caché
	// if (imageCache[url_image]) {
	// 	return imageCache[url_image];
	// }

	try {
		const response = await apiClient.post(`${url.DOWNLOAD_IMAGE_SAS_TOKEN}?${stringifyParams({ url: url_image })}`, null);
		const imageUrl = response;

		// Almacena la URL de la imagen en la caché
		imageCache[url_image] = imageUrl;

		return imageUrl;
	} catch (error) {
		console.error('Error downloading image:', error);
		throw error;
	}
};
